import { render, staticRenderFns } from "./TextConsole.vue?vue&type=template&id=0d6f79c1&scoped=true&lang=pug"
import script from "./TextConsole.vue?vue&type=script&lang=js"
export * from "./TextConsole.vue?vue&type=script&lang=js"
import style0 from "./TextConsole.vue?vue&type=style&index=0&id=0d6f79c1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d6f79c1",
  null
  
)

export default component.exports